import React from 'react';
import PropTypes from 'prop-types';

import FormGroup from '../../FormGroup';
import CustomPrintPhotoPlaceholder from '../components/CustomPrintPhoto/CustomPrintPhotoPlaceholder';

const propTypes = {
  albumCustomPrint: PropTypes.shape({
    id: PropTypes.string.isRequired,
    photos_no: PropTypes.number.isRequired,
    custom_print_caption_enabled: PropTypes.bool,
  }).isRequired,
  config: PropTypes.shape({
    caption: PropTypes.string,
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        photo: PropTypes.shape({
          id: PropTypes.string.isRequired,
        }),
        position: PropTypes.number.isRequired,
        cropbox: PropTypes.object,
      }),
    ),
  }).isRequired,
  onCaptionChange: PropTypes.func.isRequired,
  onTriggerPhotoSelection: PropTypes.func.isRequired,
};

const CustomPrintGenericTemplate = ({
  albumCustomPrint,
  config,
  onCaptionChange,
  onTriggerPhotoSelection,
}) => {
  const positions = Array.from({ length: albumCustomPrint.photos_no });

  return (
    <div className="custom-print-config-generic">
      <p className="text-italic text-sm">
        Note the photographer will adjust the crop and size of each photo for
        best results before printing.
      </p>

      {albumCustomPrint.custom_print_caption_enabled && (
        <FormGroup
          id="custom-print-caption"
          className="mb-3"
          name="caption"
          label="Enter your caption"
          labelTip="The caption of your choosing will be printed on your print."
          labelTipPlace="bottom"
          value={config.caption}
          onChange={onCaptionChange}
        />
      )}

      <div className="custom-print-config-generic-photo-grid">
        {positions.map((_, index) => {
          const selectedPhoto = config.photos.find(
            photo => photo.position === index,
          );

          return (
            <CustomPrintPhotoPlaceholder
              key={index}
              position={index}
              photo={selectedPhoto?.photo}
              onEdit={onTriggerPhotoSelection}
            />
          );
        })}
      </div>
    </div>
  );
};

CustomPrintGenericTemplate.propTypes = propTypes;

export default CustomPrintGenericTemplate;
